import { defineComponent as pe, inject as he, ref as C, computed as k, unref as r, onMounted as be, nextTick as U, watch as we, openBlock as c, createElementBlock as a, normalizeClass as d, Fragment as m, renderList as D, createBlock as A, withCtx as P, createTextVNode as E, toDisplayString as w, createCommentVNode as H, withDirectives as V, createVNode as j, createElementVNode as ve } from "vue";
import { ElScrollbar as Se } from "./index674.js";
import { ElIcon as q } from "./index538.js";
import { ArrowUp as ge, ArrowDown as _e } from "./index537.js";
import { PICKER_BASE_INJECTION_KEY as Me, timeUnits as z, DEFAULT_FORMATS_TIME as Ce } from "./index579.js";
import { buildTimeList as L } from "./index578.js";
import { basicTimeSpinnerProps as ke } from "./index723.js";
import { getTimeLists as De } from "./index595.js";
import { vRepeatClick as K } from "./index697.js";
import { CHANGE_EVENT as G } from "./index584.js";
import { useNamespace as Ee } from "./index559.js";
import { getStyle as Te } from "./index641.js";
import { isNumber as $e } from "./index565.js";
import Ie from "./index724.js";
const Ne = ["onClick"], Re = ["onMouseenter"];
var Ge = /* @__PURE__ */ pe({
  __name: "basic-time-spinner",
  props: ke,
  emits: [G, "select-range", "set-option"],
  setup(J, { emit: Y }) {
    const i = J, Q = he(Me), { isRange: W, format: X } = Q.props, S = Y, l = Ee("time"), { getHoursList: Z, getMinutesList: y, getSecondsList: ee } = De(
      i.disabledHours,
      i.disabledMinutes,
      i.disabledSeconds
    );
    let T = !1;
    const g = C(), se = C(), oe = C(), ne = C(), h = {
      hours: se,
      minutes: oe,
      seconds: ne
    }, F = k(() => i.showSeconds ? z : z.slice(0, 2)), f = k(() => {
      const { spinnerDate: e } = i, o = e.hour(), s = e.minute(), n = e.second();
      return { hours: o, minutes: s, seconds: n };
    }), _ = k(() => {
      const { hours: e, minutes: o } = r(f), { role: s, spinnerDate: n } = i, t = W ? void 0 : n;
      return {
        hours: Z(s, t),
        minutes: y(e, s, t),
        seconds: ee(e, o, s, t)
      };
    }), re = k(() => {
      const { hours: e, minutes: o, seconds: s } = r(f);
      return {
        hours: L(e, 23),
        minutes: L(o, 59),
        seconds: L(s, 59)
      };
    }), te = Ie((e) => {
      T = !1, v(e);
    }, 200), B = (e) => {
      if (!!!i.amPmMode) return "";
      const s = i.amPmMode === "A";
      let n = e < 12 ? " am" : " pm";
      return s && (n = n.toUpperCase()), n;
    }, p = (e) => {
      let o = [0, 0];
      const s = X || Ce, n = s.indexOf("HH"), t = s.indexOf("mm"), u = s.indexOf("ss");
      switch (e) {
        case "hours":
          n !== -1 && (o = [n, n + 2]);
          break;
        case "minutes":
          t !== -1 && (o = [t, t + 2]);
          break;
        case "seconds":
          u !== -1 && (o = [u, u + 2]);
          break;
      }
      const [M, b] = o;
      S("select-range", M, b), g.value = e;
    }, v = (e) => {
      I(e, r(f)[e]);
    }, O = () => {
      v("hours"), v("minutes"), v("seconds");
    }, $ = (e) => e.querySelector(`.${l.namespace.value}-scrollbar__wrap`), I = (e, o) => {
      if (i.arrowControl) return;
      const s = r(h[e]);
      s && s.$el && ($(s.$el).scrollTop = Math.max(
        0,
        o * N(e)
      ));
    }, N = (e) => {
      const o = r(h[e]), s = o?.$el.querySelector("li");
      return s && Number.parseFloat(Te(s, "height")) || 0;
    }, ie = () => {
      R(1);
    }, ce = () => {
      R(-1);
    }, R = (e) => {
      g.value || p("hours");
      const o = g.value, s = r(f)[o], n = g.value === "hours" ? 24 : 60, t = le(o, s, e, n);
      x(o, t), I(o, t), U(() => p(o));
    }, le = (e, o, s, n) => {
      let t = (o + s + n) % n;
      const u = r(_)[e];
      for (; u[t] && t !== o; )
        t = (t + s + n) % n;
      return t;
    }, x = (e, o) => {
      if (r(_)[e][o]) return;
      const { hours: t, minutes: u, seconds: M } = r(f);
      let b;
      switch (e) {
        case "hours":
          b = i.spinnerDate.hour(o).minute(u).second(M);
          break;
        case "minutes":
          b = i.spinnerDate.hour(t).minute(o).second(M);
          break;
        case "seconds":
          b = i.spinnerDate.hour(t).minute(u).second(o);
          break;
      }
      S(G, b);
    }, ae = (e, { value: o, disabled: s }) => {
      s || (x(e, o), p(e), I(e, o));
    }, ue = (e) => {
      const o = r(h[e]);
      if (!o) return;
      T = !0, te(e);
      const s = Math.min(
        Math.round(
          ($(o.$el).scrollTop - (me(e) * 0.5 - 10) / N(e) + 3) / N(e)
        ),
        e === "hours" ? 23 : 59
      );
      x(e, s);
    }, me = (e) => r(h[e]).$el.offsetHeight, de = () => {
      const e = (o) => {
        const s = r(h[o]);
        s && s.$el && ($(s.$el).onscroll = () => {
          ue(o);
        });
      };
      e("hours"), e("minutes"), e("seconds");
    };
    be(() => {
      U(() => {
        !i.arrowControl && de(), O(), i.role === "start" && p("hours");
      });
    });
    const fe = (e, o) => {
      h[o].value = e ?? void 0;
    };
    return S("set-option", [`${i.role}_scrollDown`, R]), S("set-option", [`${i.role}_emitSelectRange`, p]), we(
      () => i.spinnerDate,
      () => {
        T || O();
      }
    ), (e, o) => (c(), a(
      "div",
      {
        class: d([r(l).b("spinner"), { "has-seconds": e.showSeconds }])
      },
      [
        e.arrowControl ? H("v-if", !0) : (c(!0), a(
          m,
          { key: 0 },
          D(F.value, (s) => (c(), A(r(Se), {
            key: s,
            ref_for: !0,
            ref: (n) => fe(n, s),
            class: d(r(l).be("spinner", "wrapper")),
            "wrap-style": "max-height: inherit;",
            "view-class": r(l).be("spinner", "list"),
            noresize: "",
            tag: "ul",
            onMouseenter: (n) => p(s),
            onMousemove: (n) => v(s)
          }, {
            default: P(() => [
              (c(!0), a(
                m,
                null,
                D(_.value[s], (n, t) => (c(), a("li", {
                  key: t,
                  class: d([
                    r(l).be("spinner", "item"),
                    r(l).is("active", t === f.value[s]),
                    r(l).is("disabled", n)
                  ]),
                  onClick: (u) => ae(s, { value: t, disabled: n })
                }, [
                  s === "hours" ? (c(), a(
                    m,
                    { key: 0 },
                    [
                      E(
                        w(("0" + (e.amPmMode ? t % 12 || 12 : t)).slice(-2)) + w(B(t)),
                        1
                        /* TEXT */
                      )
                    ],
                    64
                    /* STABLE_FRAGMENT */
                  )) : (c(), a(
                    m,
                    { key: 1 },
                    [
                      E(
                        w(("0" + t).slice(-2)),
                        1
                        /* TEXT */
                      )
                    ],
                    64
                    /* STABLE_FRAGMENT */
                  ))
                ], 10, Ne))),
                128
                /* KEYED_FRAGMENT */
              ))
            ]),
            _: 2
            /* DYNAMIC */
          }, 1032, ["class", "view-class", "onMouseenter", "onMousemove"]))),
          128
          /* KEYED_FRAGMENT */
        )),
        e.arrowControl ? (c(!0), a(
          m,
          { key: 1 },
          D(F.value, (s) => (c(), a("div", {
            key: s,
            class: d([r(l).be("spinner", "wrapper"), r(l).is("arrow")]),
            onMouseenter: (n) => p(s)
          }, [
            V((c(), A(r(q), {
              class: d(["arrow-up", r(l).be("spinner", "arrow")])
            }, {
              default: P(() => [
                j(r(ge))
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class"])), [
              [r(K), ce]
            ]),
            V((c(), A(r(q), {
              class: d(["arrow-down", r(l).be("spinner", "arrow")])
            }, {
              default: P(() => [
                j(r(_e))
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class"])), [
              [r(K), ie]
            ]),
            ve(
              "ul",
              {
                class: d(r(l).be("spinner", "list"))
              },
              [
                (c(!0), a(
                  m,
                  null,
                  D(re.value[s], (n, t) => (c(), a(
                    "li",
                    {
                      key: t,
                      class: d([
                        r(l).be("spinner", "item"),
                        r(l).is("active", n === f.value[s]),
                        r(l).is("disabled", _.value[s][n])
                      ])
                    },
                    [
                      r($e)(n) ? (c(), a(
                        m,
                        { key: 0 },
                        [
                          s === "hours" ? (c(), a(
                            m,
                            { key: 0 },
                            [
                              E(
                                w(("0" + (e.amPmMode ? n % 12 || 12 : n)).slice(-2)) + w(B(n)),
                                1
                                /* TEXT */
                              )
                            ],
                            64
                            /* STABLE_FRAGMENT */
                          )) : (c(), a(
                            m,
                            { key: 1 },
                            [
                              E(
                                w(("0" + n).slice(-2)),
                                1
                                /* TEXT */
                              )
                            ],
                            64
                            /* STABLE_FRAGMENT */
                          ))
                        ],
                        64
                        /* STABLE_FRAGMENT */
                      )) : H("v-if", !0)
                    ],
                    2
                    /* CLASS */
                  ))),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ],
              2
              /* CLASS */
            )
          ], 42, Re))),
          128
          /* KEYED_FRAGMENT */
        )) : H("v-if", !0)
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  Ge as default
};
